import React from 'react';

class About extends React.Component {
    render() {
        return (
            <React.Fragment>
                <span>
                    This app helps with daily todos.
                </span>
            </React.Fragment>
        );
    }
}

export default About;